// import logo from './images/QuyvaLogo.png'; 
import { Config } from 'config/envConfig';
// App info.
export const appName = 'Quyva';
export const appURL = 'http://quyva.mtree.co.in/';
export const contactEmail = 'quyva@mtree.co.in';
export const contactNumber = '';
// export const appLogo = logo;
export const appLogo = `${Config.PUBLIC_URL}/QuyvaLogo.png`;
export const companyLogo = `${Config.PUBLIC_URL}/mtree-logo.png`;
export const appVersion = '1.0.0';
